import { GlobalState } from "context/GlobalContext";
import { useEffect, useState } from "react";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError";
import { Box, Stack, Typography } from "@mui/material";
import MarimekkoChart from "components/Reports/ReusableComponents/MarimekkoChart/MarimekkoChart";
import { fastapiVmInstance } from "utils/AxiosInstances/RareboxFastApi";
import DounutRelatedCards from "../DounutRelatedCards/DounutRelatedCards";
import DounutChart from "components/Reports/ReusableComponents/DounutChart/DounutChart";
import { dounuts } from "../DounutRelatedCards/data";

function sortBySales(data) {
  return data
    .map(category => {
      // Sort segments by descending sales
      const sortedSegments = [...category.segments].sort((a, b) => b.sales - a.sales);

      // Calculate total sales for category
      const totalSales = sortedSegments.reduce((sum, seg) => sum + seg.sales, 0);

      return {
        ...category,
        segments: sortedSegments,
        total_sales: totalSales
      };
    })
    // Sort categories by total sales descending
    .sort((a, b) => b.total_sales - a.total_sales);
}

const defaultArcData ={
    "color":[],
    "fabric":[],
    "fit":[],
    "size":[],
    "fashionability":[]
}

const sortedData = (data,order = "desc") =>{

    const sortedData = Object.fromEntries(
      Object.entries(data).map(([key, arr]) => [
        key,
        Array.isArray(arr)
        ? [...arr].sort((a, b) =>
            order === "asc" ? a.qty - b.qty : b.qty - a.qty
          )
        : arr,
      ])
    );
return sortedData;
}

const MarimekkoRelatedCards = ({ filter, width=1560, height=700, color
 }) => {
    const { setSnackBarOpen, setSnackBar, snackbar } = GlobalState();
    const [guildData, setGuildData] = useState([]);
    const [nonGuildData, setNonGuildData] = useState([]);
    const [guildSelectedSegemnt, setGuildSelectedSegemnt] = useState(null);
    const [nonguildSelectedSegemnt, setNonguildSelectedSegemnt] = useState(null);
    const [guildSelectedArc, setGuildSelectedArc] = useState(null);
    const [nonguildSelectedArc, setNonguildSelectedArc] = useState(null);
    const [guildArcData, setGuildArcData] = useState(defaultArcData);
    const [nonGuildArcData, setNonGuildArcData] = useState(defaultArcData);
    const [loading, setLoading] = useState(true);

    const fetch = async () => {
        try {
            setLoading(true);
            const body = { filter };
            console.log('awdfgahijodklajsdh', filter)

            const res = await fastapiVmInstance.post(`/api/summary-report/summary-marimekko-diagram`, {filter});

            if (res.data.status === "error") throw new Error(res.data?.message);
            const result = res.data.result;
            setGuildData(sortBySales(result?.GUILD) || []);
            setNonGuildData(sortBySales(result?.NON_GUILD) || []);
            setLoading(false);
        } catch (error) {
            setSnackBarOpen(true);
            setSnackBar({
                message: parseErrMsgFromError(error),
                severity: "error",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
        }
    };

    const arcFetch = async (sub_brand = "",name = "" ,data = "") => {
        try {
            // setLoading(true);
            // const arcSelected = 
            let body = {}
            if (sub_brand === "GUILD"){
                if (name === "marimekko"){
                    body = { category: data?.category, pattern: data?.segment?.type};
                }
                if (name === "dounut"){
                    dounuts.forEach((d) =>{
                        if (d?.name === data?.chartName){
                            body["dounut_col"] = d["key"]
                            body["dounut_val"] = data?.label
                        }
                    })
                    if (guildSelectedSegemnt)
                    body = {...body, category: guildSelectedSegemnt?.category, pattern: guildSelectedSegemnt?.segment?.type };
                }
            }
            if (sub_brand === "NON_GUILD"){
                if (name === "marimekko"){
                    body = { category: data?.category, pattern: data?.segment?.type };
                }
                if (name === "dounut"){
                    dounuts.forEach((d) =>{
                        if (d?.name === data?.chartName){
                            body["dounut_col"] = d["key"]
                            body["dounut_val"] = data?.label
                        }
                    })
                    if (nonguildSelectedSegemnt)
                    body = {...body, category: nonguildSelectedSegemnt?.category, pattern: nonguildSelectedSegemnt?.segment?.type };
                }
            }
            // console.log('awdfgahijodklajsdh', filter)

            const res = await fastapiVmInstance.post(`/api/summary-report/summary-marimekko-donut-diagram/${sub_brand}`, {filter, ...body});

            if (res.data.status === "error") throw new Error(res.data?.message);
            const result = res.data.result;
            if (sub_brand === "GUILD"){
                let selectedData = data ? {...defaultArcData} : result
                data && Object.keys(result).forEach((arc) => {
                    if (arc === data.chart_id) {
                        selectedData[data.chart_id] = guildArcData[arc]
                    }
                    else{
                        selectedData[arc] = result[arc]
                    }
                })
                // console.log("ADadascasfiausydtrafgs", selectedData)
                setGuildArcData(sortedData(selectedData))
            }
            if (sub_brand === "NON_GUILD"){
                let selectedData = data ? {...defaultArcData} : result
                data && Object.keys(result).forEach((arc) => {
                    if (arc === data.chart_id) {
                        selectedData[data.chart_id] = nonGuildArcData[arc]
                    }
                    else{
                        selectedData[arc] = result[arc]
                    }
                })
                // console.log("ADadascasfiausydtrafgs", selectedData)
                setNonGuildArcData(sortedData(selectedData))
            }
            setLoading(false);
        } catch (error) {
            setSnackBarOpen(true);
            setSnackBar({
                message: parseErrMsgFromError(error),
                severity: "error",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
        }
    };

    useEffect(() => {
        setGuildSelectedArc(null)
        setGuildSelectedSegemnt(null)
        setNonguildSelectedArc(null)
        setNonguildSelectedSegemnt(null)
        setGuildArcData(defaultArcData)
        setNonGuildArcData(defaultArcData)
        fetch();
        arcFetch("GUILD")
        arcFetch("NON_GUILD")
    }, [filter]);

    const handalMarimekkoData = (data) =>{
        console.log("dfghjkl", data)
        setGuildArcData(defaultArcData)
        setGuildSelectedSegemnt(data);
        setGuildSelectedArc(null)
        arcFetch("GUILD","marimekko", data)
    }
    const handalDounutData = (data) =>{
        console.log("handalDounutData", data)
        let selectedData = {...defaultArcData}
        data && Object.keys(guildArcData).forEach((arc) => {
            if (arc === data.chart_id) {
                selectedData[data.chart_id] = guildArcData[arc]
            }
        })
        console.log("guildSelectedSegemnt1", selectedData)
        setGuildArcData(selectedData)
        setGuildSelectedArc(data);
        arcFetch("GUILD","dounut", data)
    }
    const handalMarimekkoNonGuildData = (data) =>{
        console.log("dfghjkl", data)
        setNonGuildArcData(defaultArcData)
        setNonguildSelectedSegemnt(data);
        setNonguildSelectedArc(null)
        arcFetch("NON_GUILD","marimekko", data)
    }
    const handalDounutNonGuildData = (data) =>{
        console.log("handalDounutData NG", data)
        let selectedData = {...defaultArcData}
        data && Object.keys(nonGuildArcData).forEach((arc) => {
            if (arc === data.chart_id) {
                selectedData[data.chart_id] = nonGuildArcData[arc]
            }
        })
        console.log("guildSelectedSegemnt1 NG", selectedData)
        setNonGuildArcData(selectedData)
        setNonguildSelectedArc(data);
        arcFetch("NON_GUILD", "dounut", data)
    }

    console.log("guildSelectedSegemnt", guildSelectedSegemnt, guildSelectedArc, guildArcData);

        return (
            <Stack direction="row" spacing={10} alignItems="center" margin="10px 0px">
                <Stack direction="column">
                    <Typography sx={{fontSize:"var(--font-size-h1)"}} fontWeight="400" marginBottom="10px">GUILD</Typography>
                    <Stack direction="column" height={height} spacing={2} justifyContent="space-between" backgroundColor="#fff" padding={2} borderRadius={2} boxShadow="0px 2px 4px rgba(0, 0, 0, 0.1)">
                        <MarimekkoChart data={guildData} width={width} height={height} loading={loading} selectedSegemnt={guildSelectedSegemnt} setSelectedSegemnt={handalMarimekkoData} colors = {color} />
                    </Stack>
                    <Stack marginTop="20px" direction="row" spacing={3} justifyContent="space-between" alignItems="center">
                        <Stack  height={450} spacing={1} backgroundColor="#fff" padding={2} borderRadius={2} boxShadow="0px 2px 4px rgba(0, 0, 0, 0.1)">
                            <Box height={"50px"}>
                                <Typography fontSize={"var(--font-size-h3)"} fontWeight={600}>{guildSelectedSegemnt && `${guildSelectedSegemnt.category} ${guildSelectedSegemnt?.segment?.type}, ` }{guildSelectedArc && `${guildSelectedArc?.chartName}: ${guildSelectedArc?.label}`}</Typography>
                            </Box>
                            <Stack direction="row" ustifyContent="space-between" spacing={3}>
                                {dounuts.map((arc) => (
                                    <DounutChart chart_id={arc?.key} data={guildArcData[arc?.key]} chartName={arc?.name} loading={loading} selectedArc={guildSelectedArc} setSelectedArc={handalDounutData} colors = {color} />
                                ))}
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack direction="column">
                    <Typography variant="h5" fontWeight="400" marginBottom="10px">NON GUILD</Typography>
                    <Stack direction="row" height={height} spacing={2} justifyContent="space-between" backgroundColor="#fff" padding={2} borderRadius={2} boxShadow="0px 2px 4px rgba(0, 0, 0, 0.1)">
                        <MarimekkoChart data={nonGuildData} width={width} height={height} loading={loading} selectedSegemnt={nonguildSelectedSegemnt} setSelectedSegemnt={handalMarimekkoNonGuildData} colors = {color} />
                    </Stack>
                    <Stack marginTop="20px" direction="row" spacing={3} justifyContent="space-between" alignItems="center">
                        <Stack  height={450} spacing={1} backgroundColor="#fff" padding={2} borderRadius={2} boxShadow="0px 2px 4px rgba(0, 0, 0, 0.1)">
                            <Box height={"50px"}>
                                <Typography fontSize={"26px"} fontWeight={600}>{nonguildSelectedSegemnt && `${nonguildSelectedSegemnt.category} ${nonguildSelectedSegemnt?.segment?.type}, ` }{nonguildSelectedArc && `${nonguildSelectedArc?.chartName}: ${nonguildSelectedArc?.label}`}</Typography>
                            </Box>
                            <Stack direction="row" ustifyContent="space-between" spacing={3}>
                                {dounuts.map((arc) => (
                                    <DounutChart chart_id={arc?.key} data={nonGuildArcData[arc?.key]} chartName={arc?.name} loading={loading} selectedArc={nonguildSelectedArc} setSelectedArc={handalDounutNonGuildData} colors = {color} />
                                ))}
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        );
};

export default MarimekkoRelatedCards;
